import { render } from "./DirectDebitTemplate.vue?vue&type=template&id=425dee26&scoped=true&ts=true"
import script from "./DirectDebitTemplate.vue?vue&type=script&lang=ts"
export * from "./DirectDebitTemplate.vue?vue&type=script&lang=ts"

import "./DirectDebitTemplate.vue?vue&type=style&index=0&id=425dee26&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425dee26"]])

export default __exports__